import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { mapDispatchSet } from '../../utils/redux';

const initialState = {
  activeAccountId: "",
  searchQuery: "",
  promptAddAccount: false,
  submitDisabled: false,
  accountVariables: {} as { [key: string]: any },
  lastUpdated: 0,
};

export const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    reset: (state) => {
      state.activeAccountId = "";
      state.promptAddAccount = false;
      state.submitDisabled = false;
      state.accountVariables = {};
      state.lastUpdated = Date.now();
    },

    setActiveAccountId: (state, action: PayloadAction<string>) => {
      state.activeAccountId = action.payload;
      state.lastUpdated = Date.now();
    },

    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },

    setPromptAddAccount: (state, action: PayloadAction<boolean>) => {
      state.promptAddAccount = action.payload;
    },

    setSubmitDisabled: (state, action: PayloadAction<boolean>) => {
      state.submitDisabled = action.payload;
    },

    setAccountVariable: (state, action: PayloadAction<[string, any]>) => {
      const [key, value] = action.payload;
      state.accountVariables[key] = value;
      state.lastUpdated = Date.now();
    },

    setAllAccountVariables: (state, action: PayloadAction<any>) => {
      state.accountVariables = action.payload;
      state.lastUpdated = Date.now();
    },
  },
});

export const actions = mapDispatchSet(accountsSlice.actions);
